"use client";
import { useJwtToken } from "@website/hooks/auth-manager";
import { isChannel } from "@website/utils/channel/helpers";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useEffect, useMemo, useState } from "react";
export const useWelcomeScreen = () => {
  const now = Date.now();
  const router = useCompatRouter();
  const { phoneNumber } = useJwtToken();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const raw = localStorage.getItem("lastTimeWelcomeScreenShowed");
    const lastShow = raw ? new Date(raw).getTime() : 0;
    const diffSec = lastShow
      ? (now - lastShow) / 1000
      : Number.POSITIVE_INFINITY;

    setShow(() => (!lastShow || diffSec >= 86_400) && window.innerWidth < 768);
  }, [phoneNumber, router?.asPath, router?.query, router?.pathname, show]);

  const isWelcomeScreen = useMemo(() => {
    if (typeof window !== "undefined") {
      return (
        show &&
        !phoneNumber &&
        isChannel(["android"]) &&
        !router?.asPath?.includes("shopping") &&
        !router?.asPath?.includes("checkout") &&
        !router?.asPath?.includes("profile")
      );
    }
  }, [phoneNumber, router?.asPath, router?.query, router?.pathname, show]);

  return {
    isWelcomeScreen
  };
};
